var _rect, _text, _text2, _rect2, _text3, _text4, _rect3, _text5, _line, _line2, _polygon, _polygon2, _text6, _rect4, _text7, _text8, _rect5, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _rect6, _text16, _text17, _rect7, _text18, _line3, _line4, _line5, _rect8, _text19, _rect9, _text20, _rect10, _text21, _text22, _text23, _text24, _rect11, _text25, _text26, _text27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehavioralVsStructural(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 440",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boxGradBvS",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 440,
    rx: 8,
    fill: "#0C0C0C",
    stroke: "#DCCA87",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 32,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#DCCA87",
    letterSpacing: 2,
    opacity: 0.7
  }, "MCP STATELESS: THE OBSERVABILITY INFLECTION")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 52,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#777777"
  }, "Protocol-level sessions removed (July 2026). Who reconstructs session intelligence?")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 340,
    height: 330,
    rx: 6,
    fill: "url(#boxGradBvS)",
    stroke: "#666666",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 108,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#888888",
    fontWeight: 500
  }, "MCP Before (Stateful)")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 126,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#555555"
  }, "Mcp-Session-Id header, initialize/initialized")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 150,
    width: 100,
    height: 50,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#555",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 178,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#AAAAAA"
  }, "Client")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 175,
    x2: 220,
    y2: 175,
    stroke: "#888",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 175,
    x2: 170,
    y2: 175,
    stroke: "#888",
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "218,171 226,175 218,179",
    fill: "#888"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "172,171 164,175 172,179",
    fill: "#888"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 165,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#666"
  }, "session")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 150,
    width: 130,
    height: 50,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#555",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 287,
    y: 172,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#AAAAAA"
  }, "MCP Server")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 287,
    y: 188,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#555"
  }, "(holds session state)")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 215,
    width: 160,
    height: 24,
    rx: 3,
    fill: "none",
    stroke: "#555",
    strokeWidth: 1,
    strokeDasharray: "3,2"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 231,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fill: "#666"
  }, "Mcp-Session-Id: abc123")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 270,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#888888"
  }, "Protocol knew about sessions.")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 288,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#888888"
  }, "Sticky routing required.")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 306,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#888888"
  }, "Couldn't scale behind LB.")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 336,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#cc6666"
  }, "Session intelligence? Minimal.")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 354,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#cc6666"
  }, "Behavioral analysis? None.")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 372,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#cc6666"
  }, "Just connection persistence.")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 80,
    width: 340,
    height: 330,
    rx: 6,
    fill: "url(#boxGradBvS)",
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 108,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#DCCA87",
    fontWeight: 500
  }, "MCP After (Stateless)")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 126,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#555555"
  }, "Each request independent, round-robin LB")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 150,
    width: 100,
    height: 50,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 178,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#AAAAAA"
  }, "Client")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 160,
    x2: 610,
    y2: 145,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 175,
    x2: 610,
    y2: 175,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 190,
    x2: 610,
    y2: 205,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 132,
    width: 80,
    height: 28,
    rx: 3,
    fill: "#1a1a1a",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 652,
    y: 150,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "Instance 1")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 163,
    width: 80,
    height: 28,
    rx: 3,
    fill: "#1a1a1a",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 652,
    y: 181,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "Instance 2")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 194,
    width: 80,
    height: 28,
    rx: 3,
    fill: "#1a1a1a",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 652,
    y: 212,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "Instance N")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 256,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Protocol has no session awareness.")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 274,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Each request is independent.")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 292,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Scales perfectly.")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 310,
    width: 280,
    height: 70,
    rx: 4,
    fill: "#1a1810",
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 335,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Who owns session intelligence?")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 356,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "The observability layer.")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 372,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Behavioral Intelligence.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehavioralVsStructural);
export default __webpack_public_path__ + "static/media/behavioral-vs-structural.e114c8cfc3cfe6418311654f7c66e8ae.svg";
export { ForwardRef as ReactComponent };